export default "assets/images/icons/arrow-back-cdc4e652.svg";